import { render } from "./SignUpModel.vue?vue&type=template&id=059329bb&scoped=true"
import script from "./SignUpModel.vue?vue&type=script&lang=js"
export * from "./SignUpModel.vue?vue&type=script&lang=js"

import "./SignUpModel.vue?vue&type=style&index=0&id=059329bb&scoped=true&lang=css"

import exportComponent from "/var/www/html/smartbooking/smartbooking-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-059329bb"]])

export default __exports__